// Copyright: IQGeo Limited 2010-2019
import _ from 'underscore';
import myw from 'myWorld/base/core';
import './layerControlWidget';

/**
 * @class Allows Opacity control for a layer.
 * @name EsriLegendLayerControlWidget
 * @constructor
 * @extends {LayerControlWidget}
 */
myw.EsriLegendLayerControlWidget = myw.ILayerControlWidget.extend({
    tagName: 'div',
    className: 'esri-legend',

    events: {
        click: 'noop'
    },

    render() {
        const layer = this.options.layer;
        const ds = layer.datasource;
        const esriMapName = layer.layerDef.esriMap;
        const esriMapDef = ds.maps[esriMapName];

        ds.ensureLoggedIn()
            .then(() => ds.getLegendInfo(layer.layerDef))
            .catch(reason => {
                myw.trace('esri', 1, `Unable to obtain legend for ${esriMapName}: `, reason);
                return [];
            })
            .then(result => {
                _.each(result.layers, layerResult => {
                    const featureTypeInfo = _.findWhere(esriMapDef, {
                        layerId: layerResult.layerId
                    });
                    const externalName = featureTypeInfo
                        ? featureTypeInfo.external_name
                        : layerResult.layerName;
                    if (layerResult.legend.length > 1) {
                        this.$el.append(`<div class="heading">${externalName}</div>`);
                    }
                    _.each(layerResult.legend, legendItem => {
                        const label =
                            legendItem.label && legendItem.label.length
                                ? legendItem.label
                                : layerResult.legend.length > 1
                                ? ''
                                : externalName;
                        this.$el.append(
                            `<div><div class="icon"><img height="16px" src="data:${legendItem.contentType};base64,${legendItem.imageData}"/></div><span class="label">${label}</span>`
                        );
                    });
                });
            });
    },

    noop(ev) {
        ev.stopPropagation();
    }
});

export default myw.EsriLegendLayerControlWidget;
